import {
  getBillBrandTableColumn,
  getProjectTableColumn,
  getAccountTableColumn,
  getTagTableColumn,
  getCopyWithContentTableColumn,
  getTimeTableColumn,
} from '@/utils/common/tableColumn'
import { numerify } from '@/filters'
import i18n from '@/locales'
import { mathRoundFix } from '@/utils/utils'
import { currencyUnitMap } from '@/constants/currency'
import { CHARGE_TYPE, PROJECT_TYPE, PRECISION } from '@Bill/constants'
import { getBillResourceTypeLabel } from '@Bill/utils'

export default {
  data () {
    return {
      originColumns: [
        {
          field: 'id',
          title: i18n.t('bill.text_134'),
          slots: {
            default: ({ row }) => {
              return [
                <div class='text-truncate'>
                  <list-body-cell-wrap copy row={row} field='id' title={row.id} />
                </div>,
              ]
            },
          },
        },
        {
          field: 'resource_name',
          title: i18n.t('bill.text_127'),
          sortable: false,
          slots: {
            default: ({ row }) => {
              return [
                <div class='text-truncate'>
                  <list-body-cell-wrap copy row={row} field='resource_name' title={row.resource_name} />
                  <list-body-cell-wrap copy row={row} field='resource_id' hideField title={row.resource_id}><span style="color: #999;">{row.resource_id}</span></list-body-cell-wrap>
                </div>,
              ]
            },
          },
        },
        {
          field: 'resource_type',
          title: i18n.t('bill.text_73'),
          formatter: ({ row }) => {
            return getBillResourceTypeLabel(row.resource_type)
          },
        },
        {
          field: 'origin_res_type',
          title: i18n.t('bill.title.origin_res_type'),
          sortable: true,
        },
        {
          field: 'product_type',
          title: i18n.t('bill.product_type'),
          sortable: true,
        },
        getCopyWithContentTableColumn({ field: 'external_id', title: i18n.t('bill.external_id') }),
        // {
        //   field: 'rate',
        //   title: i18n.t('bill.text_37'),
        //   align: 'right',
        //   headerAlign: 'right',
        //   formatter: ({ row }) => {
        //     const sign = this.currencySign || ''
        //     return `${sign}${mathRoundFix(row.rate, PRECISION, true)} ${row.price_unit || ''}`
        //   },
        // },
        getCopyWithContentTableColumn({ field: 'ip_addr', title: 'IP' }),
        {
          field: 'gross_amount',
          title: i18n.t('bill.bill_type.gross_value'),
          sortable: true,
          formatter: ({ row }) => {
            return `${this.currencySign} ${mathRoundFix(row.gross_amount || 0, PRECISION, true)}`
          },
        },
        {
          field: 'paid_amount',
          title: i18n.t('bill.bill_type.paid_value'),
          sortable: true,
          formatter: ({ row }) => {
            return `${this.currencySign} ${mathRoundFix(row.paid_amount || 0, PRECISION, true)}`
          },
        },
        {
          field: 'discount_amount',
          title: i18n.t('bill.bill_type.discount_value'),
          formatter: ({ row }) => {
            return `${this.currencySign} ${mathRoundFix((row.gross_amount || 0) - (row.amount || 0), PRECISION, true)}`
          },
        },
        {
          field: 'amount',
          title: i18n.t('bill.text_125'),
          sortable: true,
          slots: {
            default: ({ row }) => {
              const money = numerify(row.amount, '0,0.000000')
              const sign = this.currencySign || ''
              return [<list-body-cell-wrap copy row={row} field='amount' hideField title={row.amount}><div class="text-right">{sign} {money}</div></list-body-cell-wrap>]
            },
            header: () => {
              return [<span style="margin-right:5px">{i18n.t('bill.text_125')}</span>, <help-tooltip name="billNegativeNumberReson" />]
            },
          },
        },
        {
          field: 'amount_sec',
          title: i18n.t('bill.converted_amount'),
          sortable: true,
          slots: {
            default: ({ row }) => {
              const sign = currencyUnitMap[row.currency]?.sign || ''
              if (row.amount_sec) {
                const money = numerify(row.amount_sec, '0,0.000000')
                return [<list-body-cell-wrap copy row={row} field='amount_sec' hideField title={row.amount_sec}><div class="text-right">{sign} {money}</div></list-body-cell-wrap>]
              } else {
                const money = numerify(row.amount, '0,0.000000')
                return [<list-body-cell-wrap copy row={row} field='amount' hideField title={row.amount}><div class="text-right">{sign} {money}</div></list-body-cell-wrap>]
              }
            },
          },
          hidden: !(this.$store.getters.isAdminMode && this.$store.state.common.bill.globalConfig.cost_conversion_available),
        },
        {
          field: 'day',
          title: i18n.t('bill.title.day'),
          minWidth: 100,
          formatter: ({ row }) => {
            if (!row.day) return '-'
            return this.$moment(String(row.day)).format('YYYY-MM-DD')
          },
        },
        getTimeTableColumn({ field: 'instance_created_at', title: this.$t('meter.instance_create_time') }),
        getTimeTableColumn({ field: 'instance_deleted_at', title: this.$t('meter.instance_delete_time') }),
        {
          field: 'discount',
          title: this.$t('meter.discount_rate'),
          sortable: true,
          formatter: ({ row }) => {
            return row.discount || 0
          },
        },
        // {
        //   field: 'usage_unit',
        //   title: this.$t('meter.usage_unit'),
        // },
        {
          field: 'usage',
          title: i18n.t('bill.text_131'),
          // align: 'right',
          formatter: ({ row }) => {
            // let unit = row.usage_unit ? row.usage_unit.replace(/\//g, '*') : ''
            // unit = unit.startsWith('*') ? unit.substring(1) : unit
            const usage = mathRoundFix(row.usage, PRECISION) // 保留6位小数，不够也不需要补0
            return usage
          },
        },
        {
          field: 'usage_unit',
          title: this.$t('meter.usage_unit'),
          formatter: ({ row }) => {
            return row.usage_unit || '-'
          },
        },
        {
          field: 'price_unit',
          title: this.$t('meter.price_unit'),
        },
        {
          field: 'rate',
          title: this.$t('meter.unit_price'),
          sortable: true,
          formatter: ({ row }) => {
            return `${this.currencySign} ${mathRoundFix(row.rate, PRECISION)}`
          },
        },
        {
          field: 'instance_type',
          title: this.$t('meter.instance_type'),
          formatter: ({ row }) => {
            return row.instance_type || '-'
          },
        },
        {
          field: 'usage_duration',
          title: this.$t('meter.usage_duration'),
          formatter: ({ row }) => {
            return row.usage_duration || '-'
          },
        },
        {
          field: 'usage_duration_unit',
          title: this.$t('meter.usage_duration_unit'),
          formatter: ({ row }) => {
            return row.usage_duration_unit || '-'
          },
        },
        {
          field: 'aggregate_usage',
          title: this.$t('meter.aggregate_usage'),
          formatter: ({ row }) => {
            return row.aggregate_usage || '-'
          },
        },
        {
          field: 'aggregate_usage_unit',
          title: this.$t('meter.aggregate_usage_unit'),
          formatter: ({ row }) => {
            return row.aggregate_usage_unit || '-'
          },
        },
        {
          field: 'origin_record_type',
          title: this.$t('meter.origin_record_type'),
          formatter: ({ row }) => {
            return row.origin_record_type || '-'
          },
        },
        getTagTableColumn({
          field: 'tags',
          needExt: true,
          columns: () => this.columns,
          editCheck: () => false,
        }),
        getTagTableColumn({
          field: 'project_metadata',
          title: this.$t('dictionary.project_tag'),
          needExt: true,
          columns: () => this.columns,
          editCheck: () => false,
        }),
        {
          field: 'usage_type',
          title: i18n.t('bill.usage_type'),
          minWidth: 100,
          formatter: ({ row }) => row.usage_type || '-',
        },
        {
          field: 'origin_usage_type',
          title: i18n.t('bill.origin_usage_type'),
          minWidth: 100,
          formatter: ({ row }) => row.origin_usage_type || '-',
        },
        {
          field: 'charge_type',
          title: i18n.t('bill.text_84'),
          formatter: ({ row }) => CHARGE_TYPE[row.charge_type] || row.charge_type,
        },
        {
          field: 'project_type',
          title: i18n.t('bill.title.project_type'),
          formatter: ({ row }) => PROJECT_TYPE[row.project_type] || row.project_type,
        },
        getBillBrandTableColumn({ sortable: false }),
        getAccountTableColumn({ managerField: 'cloudprovider_name' }),
        getProjectTableColumn({ hidden: this.$store.getters.isProjectMode, minWidth: 'auto', field: 'project', sortable: false }),
        {
          field: 'region',
          title: i18n.t('bill.text_83'),
          hidden: this.isOperation,
        },
        {
          field: 'origin_region',
          title: i18n.t('meter.origin_region'),
        },
        {
          field: 'external_project_name',
          title: i18n.t('bill.external_project_name') + '/ID',
          sortable: false,
          slots: {
            default: ({ row }) => {
              return [
                <div class='text-truncate'>
                  <list-body-cell-wrap copy row={row} field='external_project_name' title={row.external_project_name} />
                  <list-body-cell-wrap copy row={row} field='external_project_id' hideField title={row.external_project_id}><span style="color: #999;">{row.external_project_id}</span></list-body-cell-wrap>
                </div>,
              ]
            },
          },
        },
        {
          field: 'cloudprovider_id',
          title: i18n.t('bill.cloudprovider') + '/ID',
          sortable: false,
          slots: {
            default: ({ row }) => {
              return [
                <div class='text-truncate'>
                  <list-body-cell-wrap copy row={row} field='cloudprovider_name' title={row.cloudprovider_name} />
                  <list-body-cell-wrap copy row={row} field='cloudprovider_id' hideField title={row.cloudprovider_id}><span style="color: #999;">{row.cloudprovider_id}</span></list-body-cell-wrap>
                </div>,
              ]
            },
          },
        },
        {
          field: 'spec',
          title: i18n.t('meter.bill_impact_factor'),
        },
      ],
    }
  },
  computed: {
    isOperation () {
      return process.env.VUE_APP_PLATFORM === 'operation'
    },
    columns () {
      return this.originColumns.filter(item => {
        return !this.$isScopedPolicyMenuHidden(`bill_detail_hidden_columns.${item.field}`)
      })
    },
  },
}
